import { Box } from "@mui/material";
import styled from "styled-components";

import { globalStyle } from "components";

interface IContainer {
  height?: string;
}

export const Container = styled.div<IContainer>`
  text-align: start;

  .MuiInputBase-root {
    height: ${(props) => props.height ?? "48px"};
    font-family: ${globalStyle.fontFamily};
    font-size: 14px;
  }

  .input_mui fieldset {
    border-color: ${globalStyle.input.default};
    font-family: ${globalStyle.fontFamily};
    border-width: 2px;
    padding: 12px, 16px, 12px, 16px;
    gap: 12px;
  }

  .input_mui:hover fieldset {
    border-color: ${globalStyle.input.hover};
  }

  .input_mui .Mui-focused fieldset {
    border-color: ${globalStyle.input.focus};
  }

  .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 14px 14px;
  }
`;

export const LabelContainer = styled(Box as any)`
  display: flex;
  align-items: center;
`;

export const Label = styled(Box as any)`
  margin-right: 1px;
`;

export const LabelRequired = styled(Box as any)`
  padding: 0px;
`;
